// See: backend/docs/driver-scheduler.md §11 — UI
//
// "Otomatik Sürücü Öner" butonu. Eligibility kontrolü kendi içindedir; bu sayede
// BasePersonelServiceItem'a sadece <AutoAssignButton .../> yerleştirmek yeterli olur
// ve Transfer/Shift item config'lerine dokunmaya gerek kalmaz.
//
// Eligibility:
//   - !isNewItem (servis kaydedilmiş olmalı, ID'si gereklidir)
//   - loadedItem.id mevcut
//   - loadedItem.isshift === true VEYA loadedItem.serviceType TRANSFER_* ile başlıyor
//   - loadedItem.date dolu (tek-seferlik servisler için zorunlu)
//
// Eligibility sağlanmazsa hiçbir şey render edilmez (null) — DOM'a görünmez.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "shared/components/FormElements/Button";

import AutoAssignSuggestionModal from "./AutoAssignSuggestionModal";

const isTransferServiceType = (st) => typeof st === "string" && st.startsWith("TRANSFER_");

const isEligible = (loadedItem) => {
  if (!loadedItem || !loadedItem.id) return false;
  if (!loadedItem.date) return false;
  // Hesaplanmamış servis (rota süresi / varış saati eksik) için öneri üretilemez → buton gizlenir.
  if (!(Number(loadedItem.totalDuration) > 0)) return false;
  if (!loadedItem.routeClientArrivalTime) return false;
  if (loadedItem.isshift === true) return true;
  if (isTransferServiceType(loadedItem.serviceType)) return true;
  return false;
};

const AutoAssignButton = ({ loadedItem, isNewItem, onAssigned, style }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  if (isNewItem) return null;
  if (!isEligible(loadedItem)) return null;

  return (
    <>
      <Button
        type="button"
        size="small"
        inverse
        onClick={() => setShowModal(true)}
        style={style}
      >
        {t("driverScheduler.autoAssignTitle")}
      </Button>

      <AutoAssignSuggestionModal
        show={showModal}
        onClose={() => setShowModal(false)}
        serviceId={loadedItem.id}
        serviceName={loadedItem.name}
        onAssigned={(updatedService, driverId) => {
          if (typeof onAssigned === "function") {
            onAssigned(updatedService, driverId);
          }
        }}
      />
    </>
  );
};

export default AutoAssignButton;
